import {Log} from '@aboutyou/mlm';

export const logUseRequestError = async ({
  error,
  cacheKey,
  asWarning,
  statusCode,
}: {
  cacheKey: string;
  error: unknown;
  asWarning?: boolean;
  statusCode?: number;
}) => {
  const cacheKeys = getHumanReadableKey(cacheKey);

  if (error instanceof Error && !isNetworkError(error)) {
    const message = `useRequest error: ${cacheKeys.humanReadableCacheKey}`;
    const additionalData = {
      error,
      cacheKey: cacheKeys.cacheKey,
      humanReadableCacheKey: cacheKeys.humanReadableCacheKey,
      statusCode,
    };

    if (asWarning) {
      if (process.browser) {
        Log.warn('@aboutyou/data-fetcher', message, additionalData);
      } else {
        Log.nonCriticalServerError(
          '@aboutyou/data-fetcher',
          message,
          additionalData,
        );
      }

      return;
    }

    Log.error('@aboutyou/data-fetcher', message, additionalData);
  }
};

function isNetworkError(error: Error) {
  return !!error.message.match(/network|fetch|request/i);
}

export const getHumanReadableKey = (
  cacheKey: string,
): {cacheKey: string; humanReadableCacheKey: string} => {
  try {
    // example cacheKey: "aysa_api.services.category_page.v1.stream.CategoryStreamService/GetProductStream:6764702873417" => in local development
    // example cacheKey: "@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/meta/service.grpc::ArticleDetailMetaService_GetPageMetaData:5131702094555" => in production
    const parsedKey = JSON.parse(cacheKey);
    const humanReadableCacheKey =
      parsedKey.split(':').reverse()[1]?.split('/').reverse()[0] ?? parsedKey;

    return {cacheKey: parsedKey, humanReadableCacheKey};
  } catch (error) {
    return {cacheKey, humanReadableCacheKey: cacheKey};
  }
};
